import { Api } from '@/common/api'
export default {
   
    END_POINT_DEFAULT: process.env.VUE_APP_ENDPOINT_DEFAULT,
    END_POINT_PAYMENT: process.env.VUE_APP_ENDPOINT_PAYMENT,
    END_POINT_PORTAL_CORPORATIVO: process.env.VUE_APP_ENDPOINT_PORTAL_CORPORATIVO,
    END_POINT_ACCOUNT: process.env.VUE_APP_ENDPOINT_ACCOUNT,
    END_POINT_SIGNALR: process.env.VUE_APP_ENDPOINT_SIGNALR,
    
    SSO_END_POINT: process.env.VUE_APP_ENDPOINT_SSO,

    SSO_REDIRECT_LOGIN_URL: process.env.VUE_APP_LOCATION_URL + "authorized/?",
    SSO_REDIRECT_LOGOUT_URL: "https://www.cna.com.br",

    SSO_CLIENT_ID: "shopping-customer",
    SSO_RESPONSE_TYPE: "id_token token",
    SSO_SCOPE: "openid profile email shopping_payment_api shopping_customer_api account_user_api",

    ACCESS_TOKEN: "PFB_AC_T_X857D",
    ID_TOKEN: "PFB_ID_T_D98SW",
    USER_INFO: "PFB_U_I_D8D5D",
    ID_STATE: "PFB_ID_S_852PL",

    CHAVE_IDENTIFICACAO_SISTEMA: "SHOPPING_NOVO",

    URL_CNA_ACCOUNT: process.env.VUE_APP_CNA_ACCOUNT,
    URL_PORTAL_CORPORATIVO: process.env.VUE_APP_PORTAL_CORPORATIVO,
    URL_DOWNLOAD: process.env.VUE_APP_ENDPOINT_DOWNLOAD + '/document/download/',

}
